export interface ISpinnerProps {
  text: string;
}

export default function HrText({ text }: ISpinnerProps) {
  return (
    <div className=" w-full h-5 border-b pt-2 text-center border-gray-light mt-4 mb-8">
      <span className=" bg-gray-300 px-2 text-sm text-gray-light">{text}</span>
    </div>
  );
}
